<div *ngIf="showContent; else loginTemplate">
    <app-layout></app-layout>
</div>
<ng-template #loginTemplate>
    <app-login *ngIf="currentRoute=='/'||currentRoute=='/Login'"></app-login>
    <app-change-password  *ngIf="currentRoute=='/ChangePassword'"></app-change-password>
    <app-error-page *ngIf="currentRoute=='/Error' || currentRoute?.startsWith('/Error/')"></app-error-page>
</ng-template>